import * as React from "react";
import {getAmountWithDecimalDigits, getFirstInstalmentDueDate} from "@ferry/plugin-ferry-journey";
import DirectDebitPaymentSchedule from "../../../../../components/widgets/DirectDebitPaymentSchedule";
import {InfoBanner, resourcesHelper} from "@ferry/portal-core";

interface IProps {
    interaction: any,
}

interface IState {
    isOpen: boolean;
}

export class DirectDebitRenewalPaymentPlanOutput extends React.Component <IProps, IState> {

    constructor(props: IProps) {
        super(props)

        this.state = {
            isOpen: false
        };
    }

    public render() {
        return (
            <div className="d-flex flex-row">
                <div className="d-none d-md-flex flex-column">
                    <img className="icon-panel mb-0"
                         src={`/${resourcesHelper.THEME_PATH}/img/payment-calendar.svg`}
                         alt="Payment calendar icon" aria-label="Payment calendar icon"/>
                </div>
                <div className="d-flex flex-column justify-c-center w-100">
                    <div className="d-md-none d-flex align-i-center mb-3">
                        <img className="icon-panel mb-0"
                             src={`/${resourcesHelper.THEME_PATH}/img/payment-calendar.svg`}
                             alt="Payment calendar icon" aria-label="Payment calendar icon"/>
                        <h2 className="font-family-display font-weight-bold mb-0">
                            Payment schedule
                        </h2>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2 className="font-family-display font-weight-bold d-md-block d-none mb-0">
                            Payment schedule
                        </h2>
                        <div className="bubble-container">
                            <div className="corner-bubble">Renewal only</div>
                        </div>
                    </div>
                    {this.renderContent()}
                </div>
            </div>
        )
    }

    private readonly renderContent = () => {
        const interaction = this.props.interaction
        const instalment = interaction.paymentDetails.instalmentPlan.instalments[1];
        const amount = instalment.principal + instalment.interest;
        const paymentDate: string = getFirstInstalmentDueDate(interaction).format("Do MMMM YYYY");

        return (
            <div className="mt-3 margin-top-0 grid-col-2">
                <InfoBanner wording={
                    <>
                        Your first instalment will come out on <span
                        className="font-weight-bold">{paymentDate}</span> and
                        on this day in future months. You can also change your payment day later on in your account.
                    </>
                }/>
                <p>
                    Below is a list of dates when we'll collect the payments
                    (if your preferred payment date falls on a weekend or Bank Holiday,
                    we'll take the payment on the next closest week day).
                    You have {this.props.interaction.paymentDetails.instalmentPlan.instalments.length}
                    <span className="font-weight-semi-bold"> instalments of {getAmountWithDecimalDigits(amount)}</span>
                </p>
                <div className="mb-3">
                    <DirectDebitPaymentSchedule
                        isOpen={this.state.isOpen}
                        instalments={this.props.interaction.paymentDetails.instalmentPlan.instalments || []}
                        interaction={this.props.interaction}
                        instalmentDueDates={true}
                    />
                </div>
                <div className="text-center">
                    {!this.state?.isOpen ?
                        <button className="direct-debit-btn-text text-center cursor-pointer"
                                onClick={this.toggleInstallmentPlan}>
                            + <span className="text-decoration-underline">View payment plan</span>
                        </button>
                        :
                        <button className="direct-debit-btn-text text-center cursor-pointer"
                                onClick={this.toggleInstallmentPlan}>
                            - <span className="text-decoration-underline">Hide payment plan</span>
                        </button>}
                </div>
            </div>
        )
    }

    private readonly toggleInstallmentPlan: () => void = (): void => {
        this.setState((prevState: Readonly<IState>): { isOpen: boolean } => ({
            isOpen: !prevState.isOpen
        }));
    }
}
